import React, { useEffect, useState } from "react";

import { useForm } from "react-hook-form";

import { ButtonInput } from "../Shared/Inputs/ButtonInput";
import Flyout, { FlyoutControlProps } from "../../containers/Flyout";
import { StyledSelectInput } from "../Shared/StyledInputs/StyledSelectInput";
import { useMarketingGroups } from "../../data/marketingGroup/useMarketingGroups";
import LoadingWheel from "../Shared/LoadingWheel";

interface FormValues {
  groupId: string;
}

interface AddMarketingGroupFlyoutProps extends FlyoutControlProps {
  existingGroups: string[];
  onAdd: (groupId: string) => void;
}

export function AddMarketingGroupFlyout({ open, setOpen, existingGroups, onAdd }: AddMarketingGroupFlyoutProps) {
  const { marketingGroups } = useMarketingGroups();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset
  } = useForm<FormValues>({
    defaultValues: { groupId: "" }
  });

  useEffect(() => {
    reset({ groupId: "" });
  }, [open, reset]);

  const onSubmit = (data: FormValues) => {
    if (!data.groupId || data.groupId === "") {
      return; // No group selected, do nothing
    }

    onAdd(data.groupId);
  }

  return (
    <>
      <Flyout
        open={open}
        setOpen={setOpen}
        title="Add Marketing Group"
      >
        <div>
          {marketingGroups.isLoading ? (
            <div className="flex justify-center py-10">
              <LoadingWheel width="w-8" height="h-8" />
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
              <StyledSelectInput
                label="Marketing Group"
                register={register}
                setValue={setValue}
                watch={watch}
                options={[
                  { value: "", label: "Choose Group..." },
                  ...marketingGroups.data?.data.filter(group => !existingGroups.includes(group.id)).map((group) => ({
                    value: group.id,
                    label: group.name
                  })) ?? []]}
                registerName="groupId"
              />

              <div className="mt-6 sm:col-span-2">
                <ButtonInput
                  isSubmit={true}
                  label="Add Marketing Group"
                  onClick={undefined}
                  children={undefined}
                  classes={undefined}
                />
              </div>
            </form>
          )}
        </div>
      </Flyout>
    </>
  )
}